import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
/* ANTD */
import {
  Tabs,
  Button,
  Card,
  Row,
  Col,
  Form,
  Radio,
  Checkbox,
  Input,
  Steps,
  Empty,
  Spin,
  notification,
} from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  ReadOutlined,
} from "@ant-design/icons";
/* CSS */
import "./TipoAspiranteProtesto.css";
/* DUCKS */
import {
  getTipoAspirantesTAspProtes,
  getListaProtestosTAspProtes,
  getParametrosGeneralesTAspProtes,
  getUltimoProtestoAceptadoTAspProtes,
  insertProtestoTipoAspiranteTAspProtes,
  setIsInsertProtestoTipoAspiranteTAspProtes,
  updateProtestoTipoAspiranteTAspProtes,
  setIsUpdateProtestoTipoAspiranteTAspProtes,
} from "../../../redux/aspirante/TipoAspiranteProtestoDuck";
import * as func from "../../../utils";
import { TAB_TIPO_ASP } from "../../../utils";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Step } = Steps;

export const TipoAspiranteProtestoComponent = ({idSistema}) => {
  //Declaracion Dispatch
  const dispatch = useDispatch();

  //Lectura de propiedades de STORE
  const TAspiranteProtestoStore = useSelector(
    (state) => state.tipoAspiranteProtestoStore
  );
  const usuarioLoginStore = useSelector((state) => state.usuarioLogin);
  const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
  const { estatusPostulacion } = useSelector(
    (state) => state.bloqueoEstatus.concurso
  );

  /* Forms */
  const [formTipoAspirante] = Form.useForm();
  const [formProtesto] = Form.useForm();

  const [formTipoAspiranteFields, setFormTipoAspiranteFields] = useState([]);

  //States
  const [dataDescripcion, setDataDescripcion] = useState("");
  const [dataTipoUsuario, setDataTipoUsuario] = useState("");
  const [checkedProtesto, setCheckedProtesto] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  /* States Controles de pasos para Tabs */
  const [activeStep, setActiveStep] = useState(0);

  //UseEffects
  useEffect(() => {
    dispatch(
      getUltimoProtestoAceptadoTAspProtes({
        idAspirante: usuarioLoginStore.idAspirante,
        idSistema: idSistema
      })
    );

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getTipoAspirantesTAspProtes());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TAspiranteProtestoStore.ultimoProtestoAceptado]);

  useEffect(() => {
    if (activeStep === 0) {
      dispatch(getTipoAspirantesTAspProtes());
    } else if (activeStep === 1) {
      let dataJSONListaProtestos = { "idSistema": idSistema }
      dispatch(getListaProtestosTAspProtes(dataJSONListaProtestos));
      dispatch(getParametrosGeneralesTAspProtes());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  /* Efect Insert  */
  useEffect(() => {
    if (TAspiranteProtestoStore.isInsertTAspProtes) {
      if (TAspiranteProtestoStore.isInsertTAspProtesStatus === 1) {
        notification.success({
          description: TAspiranteProtestoStore.isInsertTAspProtesMessage,
        });
        func.nextTabConfirm(
          "Los datos fueron guardados con éxito.",
          TAB_TIPO_ASP,
          "5",
          dispatch
        );
        /* Reiniciamos los Steps */
        setActiveStep(0);
      } else if (TAspiranteProtestoStore.isInsertTAspProtesStatus === -1) {
        notification.error({
          description: TAspiranteProtestoStore.isInsertTAspProtesMessage,
        });
      }
      /* Reiniciamos el mensaje de insertar para que desaparezca */
      dispatch(setIsInsertProtestoTipoAspiranteTAspProtes());
      console.log(usuarioLoginStore.idAspiran)
      /* Buscamos si el usuario ya acepto el Protesto */
      dispatch(
        getUltimoProtestoAceptadoTAspProtes({
          idAspirante: usuarioLoginStore.idAspirante,
          idSistema: idSistema
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TAspiranteProtestoStore.isInsertTAspProtes]);
  /* Efect Update */
  useEffect(() => {
    if (TAspiranteProtestoStore.isUpdateTAspProtes) {
      notification.success({
        description: TAspiranteProtestoStore.isUpdateTAspProtesMessage,
      });
      func.nextTabConfirm(
        "Los datos fueron actualizados con éxito.",
        TAB_TIPO_ASP,
        "5",
        dispatch
      );
      /* Reiniciamos los steps */
      setActiveStep(0);
      /* Reiniciamos estatus de edicion */
      changeStatusEdit();
      /* Reiniciamos el mensaje de actualizar para que desaparezca */
      dispatch(setIsUpdateProtestoTipoAspiranteTAspProtes());
      /* Buscamos si el usuario ya acepto el Protesto */
      dispatch(
        getUltimoProtestoAceptadoTAspProtes({
          idAspirante: usuarioLoginStore.idAspirante,
          idSistema: idSistema
        })
      );
      /* Reiniciamos el campo tipo aspirante */
      setFormTipoAspiranteFields([
        { name: ["tipoAspiranteField"], value: undefined },
      ]);
      /* Reiniciamos el check de aceptar Protesto */
      setCheckedProtesto(false);
    }
    // eslint-disable-next-line
  }, [TAspiranteProtestoStore.isUpdateTAspProtes]);

  useEffect(() => {
    if (isEdit) {
      setFormTipoAspiranteFields([
        {
          name: ["tipoAspiranteField"],
          value:
            TAspiranteProtestoStore.ListultimoProtestoAceptado[0].idTipoAspirante.toString(),
        },
      ]);
      setDataTipoUsuario(
        TAspiranteProtestoStore.ListultimoProtestoAceptado[0]
          .nombreTipoAspirante
      );
      setDataDescripcion(
        TAspiranteProtestoStore.ListultimoProtestoAceptado[0]
          .descripcionTipoAspirante
      );
      /* Reiniciamos el check de aceptar Protesto */
      setCheckedProtesto(false);
    } else {
      /* Reiniciamos los steps */
      setActiveStep(0);
      /* Reiniciamos el campo tipo aspirante */
      setFormTipoAspiranteFields([
        { name: ["tipoAspiranteField"], value: undefined },
      ]);
      /* Reiniciamos el check de aceptar Protesto */
      setCheckedProtesto(false);
      /* Obtenemos los datos del protesto del aspirante si ya existen */
      let dataJSONListaProtestos = { "idSistema": idSistema }
      dispatch(getListaProtestosTAspProtes(dataJSONListaProtestos));
    }
    // eslint-disable-next-line
  }, [isEdit]);

  //Functions

  /* Controles de pasos para Tabs */
  const nextStep = () => {
    setActiveStep(activeStep + 1);
  };
  const previousStep = () => {
    setActiveStep(activeStep - 1);
  };

  const setDescripcion = (titulo, descripcion) => {
    setDataTipoUsuario(titulo);
    setDataDescripcion(descripcion);
  };

  const changeCheckedProtesto = () => {
    setCheckedProtesto(!checkedProtesto);
  };

  const changeStatusEdit = () => {
    setIsEdit(!isEdit);
  };

  const guardarTipoUsuarioProtesto = () => {
    if (isEdit) {
      let dataJSON = {
        idSistema: idSistema,
        idAspirante: parseInt(usuarioLoginStore.idAspirante),
        protesto: 1,
        idTipoAspirante:
          TAspiranteProtestoStore.ListultimoProtestoAceptado[0].idTipoAspirante,
        usuario: usuarioLoginStore.correo,
        idProtesto:
          TAspiranteProtestoStore.ListultimoProtestoAceptado[0].idProtesto,
        idNTipoAspirante: parseInt(
          formTipoAspirante.getFieldValue().tipoAspiranteField
        ),
        idNProtesto: parseInt(TAspiranteProtestoStore.idListProtesto),
      };
      dispatch(updateProtestoTipoAspiranteTAspProtes(dataJSON));
    } else {
      let dataJSON = {
        idAspirante: parseInt(usuarioLoginStore.idAspirante),
        protesto: 1,
        idTipoAspirante: parseInt(
          formTipoAspirante.getFieldValue().tipoAspiranteField
        ),
        usuario: usuarioLoginStore.correo,
        idProtesto: parseInt(TAspiranteProtestoStore.idListProtesto),
      };
      dispatch(insertProtestoTipoAspiranteTAspProtes(dataJSON));
    }
  };

  return (
    <>
      <Spin spinning={TAspiranteProtestoStore.isLoading}>
        <div className="mainTipoAspProt">
          {/* <Button onClick={previousStep}  >Prev</Button> */}
          {!TAspiranteProtestoStore.ultimoProtestoAceptado || isEdit ? (
            <>
              <div className="tipoAspProtSteps">
                <div>
                  <Row className="containerSteps" align="middle">
                    <Col xs={24} md={{ span: 16, offset: 4 }}>
                      <Steps progressDot current={activeStep}>
                        <Step title="Tipo de aspirante" />
                        <Step title="Protesto" />
                      </Steps>
                    </Col>
                  </Row>
                </div>

                {/* Step 0 */}
                {activeStep === 0 && (
                  <div>
                    <Form
                      form={formTipoAspirante}
                      layout="vertical"
                      name="formTipoAspirante"
                      fields={formTipoAspiranteFields}
                    >
                      <div className="tipoAspProtTitle">
                        Nos gustaria saber más de ti
                      </div>
                      <Row>
                        <Col span={22}>
                          <div className="tipoAspProtSubtitleIcon">
                            <div className="tipoAspProtSubtitleIconImg">
                              <Button
                                type="primary"
                                shape="circle"
                                icon={<ReadOutlined />}
                              />
                            </div>
                            <div className="tipoAspProtSubtitleIconText">
                              Elige el tipo de aspirante que te describa mejor
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <div>
                        <Row>
                          <Col span={24}>
                            <Card className="cardAspirantes">
                              <>
                                <Row align="middle">
                                  <Col
                                    lg={8}
                                    xs={24}
                                    className="cardAspirantesContainer"
                                  >
                                    <Form.Item name="tipoAspiranteField">
                                      <Radio.Group>
                                        {TAspiranteProtestoStore
                                          .ListTipoAspirantes.length > 0 &&
                                          TAspiranteProtestoStore.ListTipoAspirantes.map(
                                            (item, index) => (
                                              <div key={index}>
                                                <Radio
                                                  onClick={() =>
                                                    setDescripcion(
                                                      item.nombreAspirante,
                                                      item.descripcionTipoAspirante
                                                    )
                                                  }
                                                  value={item.idTipoAspirante}
                                                >
                                                  <div className="tipoAspiranteText">
                                                    {item.nombreAspirante}
                                                  </div>
                                                </Radio>
                                                <br />
                                              </div>
                                            )
                                          )}
                                      </Radio.Group>
                                    </Form.Item>
                                  </Col>
                                  <Col
                                    lg={16}
                                    xs={24}
                                    className="cardAspirantesContainer"
                                  >
                                    {dataDescripcion !== "" ? (
                                      <div className="descripcionAspiranteText">
                                        <div className="titleDescripcion">
                                          Descripcion
                                        </div>
                                        <div className="nombreTipoUsuario">
                                          {dataTipoUsuario}
                                        </div>
                                        <div className="decripcionTipoUsuario">
                                          {dataDescripcion}
                                        </div>
                                      </div>
                                    ) : (
                                      <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                      />
                                    )}
                                  </Col>
                                </Row>
                              </>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  </div>
                )}
                {/* Step 1 */}
                {activeStep === 1 && (
                  <div>
                    <Form
                      form={formProtesto}
                      layout="vertical"
                      name="formProtesto"
                    >
                      <div className="listaProtestos">
                        <Row>
                          <Col span={24}>
                            <TextArea
                              className="listaProtestosArea"
                              rows={25}
                              value={TAspiranteProtestoStore.ListProtestos}
                            />
                          </Col>
                        </Row>
                      </div>
                      <div className="checkProtesto">
                        <div>
                          {/* Et anim excepteur laborum deserunt eu sunt adipisicing
                          excepteur dolore. Est tempor cupidatat aliquip aliqua
                          aute aute tempor id culpa. Lorem cillum laboris anim
                          enim. Dolor commodo eiusmod duis ea occaecat commodo
                          consequat dolore occaecat dolore non veniam. Ipsum ut
                          nostrud exercitation culpa ex consectetur do dolore
                          consequat officia consequat. Quis non enim nostrud
                          velit id pariatur nisi. Id reprehenderit nulla laborum
                          qui incididunt ullamco amet exercitation ipsum
                          eiusmod. */}
                        </div>
                        <br />
                        <div>
                          <Form.Item name="remember">
                            <Checkbox
                              checked={checkedProtesto}
                              onClick={changeCheckedProtesto}
                            >
                              <b>
                                {
                                  TAspiranteProtestoStore
                                    .ParametrosGeneralesProtesto.valorConfig
                                }
                              </b>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>
                    </Form>
                  </div>
                )}
                {/* Botones */}
                <div>
                  <Row>
                    <Col
                      xs={12}
                      md={{ span: 6, offset: 6 }}
                      style={{ textAlign: "center" }}
                    >
                      <Button
                        className="btnTipoAspProt"
                        type="primary"
                        htmlType="submit"
                        icon={<ArrowLeftOutlined />}
                        onClick={previousStep}
                        disabled={activeStep <= 0}
                      >
                        Anterior
                      </Button>
                    </Col>
                    <Col
                      xs={12}
                      md={{ span: 6 }}
                      style={{ textAlign: "center" }}
                    >
                      {activeStep === 0 ? (
                        <Button
                          className="btnTipoAspProt"
                          type="primary"
                          htmlType="submit"
                          icon={<ArrowRightOutlined />}
                          onClick={nextStep}
                          disabled={
                            formTipoAspirante.getFieldValue()
                              .tipoAspiranteField === undefined ||
                            bloquearPorFecha || estatusPostulacion
                          }                          
                        >
                          Siguiente
                        </Button>
                      ) : (
                        <Button
                          className="btnTipoAspProt"
                          type="primary"
                          htmlType="submit"
                          onClick={guardarTipoUsuarioProtesto}
                          disabled={!checkedProtesto}
                        >
                          Guardar
                        </Button>
                      )}
                    </Col>
                    {isEdit && (
                      <Col
                        xs={24}
                        md={{ span: 8, offset: 8 }}
                        style={{ textAlign: "center", paddingTop: "20px" }}
                      >
                        <Button
                          className="btnTipoAspProt"
                          type="primary"
                          htmlType="submit"
                          onClick={changeStatusEdit}
                        >
                          Cancelar Edición
                        </Button>
                      </Col>
                    )}
                  </Row>
                </div>
              </div>
            </>
          ) : (
            <>
              <div>
                <Tabs type="card" className="TipoAspProtTabs">
                  <TabPane
                    tab="Tipos de Aspirantes"
                    key={"1"}
                    className="TipoAspProtPane"
                  >
                    <div>
                      <Row>
                        <Col span={24}>
                          <Card className="cardAspirantes">
                            <>
                              <Row align="middle">
                                <Col
                                  span={24}
                                  className="cardAspirantesContainer"
                                >
                                  <div className="descripcionAspiranteText">
                                    <div className="titleDescripcion">
                                      Descripcion
                                    </div>
                                    {TAspiranteProtestoStore.ListultimoProtestoAceptado.map(
                                      (item, index) => (
                                        <div key={index}>
                                          <div className="nombreTipoUsuario">
                                            {item.nombreTipoAspirante}
                                          </div>
                                          <div className="decripcionTipoUsuario">
                                            {item.descripcionTipoAspirante}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </>
                          </Card>
                        </Col>
                        <Col
                          xs={24}
                          md={{ span: 8, offset: 8 }}
                          style={{ textAlign: "center" }}
                        >
                          <Button
                            className="btnTipoAspProt"
                            type="primary"
                            htmlType="submit"
                            onClick={changeStatusEdit}                            
                            disabled={bloquearPorFecha || estatusPostulacion}
                          >
                            Editar
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </TabPane>
                  <TabPane tab="Protesto" key={"2"} className="TipoAspProtPane">
                    <div>
                      <div className="listaProtestos">
                        <Row>
                          <Col span={24}>
                            <TextArea
                              className="listaProtestosArea"
                              rows={25}
                              value={TAspiranteProtestoStore.ListProtestos}
                            />
                          </Col>
                        </Row>
                      </div>
                      <div className="checkProtesto">
                        <div>
                          {/* Et anim excepteur laborum deserunt eu sunt adipisicing
                          excepteur dolore. Est tempor cupidatat aliquip aliqua
                          aute aute tempor id culpa. Lorem cillum laboris anim
                          enim. Dolor commodo eiusmod duis ea occaecat commodo
                          consequat dolore occaecat dolore non veniam. Ipsum ut
                          nostrud exercitation culpa ex consectetur do dolore
                          consequat officia consequat. Quis non enim nostrud
                          velit id pariatur nisi. Id reprehenderit nulla laborum
                          qui incididunt ullamco amet exercitation ipsum
                          eiusmod. */}
                        </div>
                        <br />
                        <div>
                          <CheckCircleOutlined
                            style={{ fontSize: "22px", color: "#0b8235" }}
                          />{" "}
                          <span>
                            <b>Protesto lo necesario.</b>
                          </span>
                        </div>
                      </div>
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </>
          )}
        </div>
      </Spin>
    </>
  );
};
